import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { connect } from 'react-redux';
import { MenuItem, FlatButton, IconButton, SelectField, Dialog } from 'material-ui';
import RefreshIcon from 'material-ui/svg-icons/navigation/refresh';
import { getProviders } from 'dash-front/inputs/common';
import { safeParse } from 'dash-front/helpers';
import { getEntities } from 'dash-front/selectors';
import { getSocialCampaigns } from 'dash-front/actions/social-campaigns';
import { fetchEventById } from 'dash-front/actions/events';
import { fetchOdds, oddsSelection, setCampaign, setProvider } from './actions';
import { CreateSocialCampaign } from './SocialCampaign';
import { emptyValue } from './constants';
import { MarketItem } from './MarketItem';

export const OddsList = connect(state => ({
    selectedCampaign: oddsSelection.select(state).selectedCampaign,
    selectedProvider: oddsSelection.select(state).selectedProvider,
    eventId: oddsSelection.select(state).eventId,
    defaultProvider: get(state, ['user', 'props', 'oddsProvider']),
    allowedProviders: get(state, ['user', 'props', 'allowedProviders']),
    socialCampaigns: getEntities(state).socialCampaigns
}))(
    class extends React.Component {
        static defaultProps = {
            markets: ['match', 'halftime', 'nextGoal', 'btts', 'goals', 'score']
        };

        static propTypes = {
            disabled: PropTypes.bool,
            markets: PropTypes.array.isRequired,
            eventId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
            defaultProvider: PropTypes.string,
            socialCampaigns: PropTypes.array,
            allowedProviders: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)])
        };

        constructor(props, ctx) {
            super(props, ctx);
            const { allowedProviders } = props;
            const providers = getProviders(safeParse(allowedProviders));
            this.state = {
                providers,
                showCreateCampaign: false
            };
        }

        componentDidMount() {
            const { eventId, dispatch, defaultProvider, allowedProviders } = this.props;
            const providers = getProviders(safeParse(allowedProviders));
            const provider =
                defaultProvider && providers.some(p => p.id === defaultProvider)
                    ? defaultProvider
                    : get(providers, [0, 'id'], emptyValue);
            dispatch(setProvider(provider));
            dispatch(getSocialCampaigns());
            if (eventId) {
                dispatch(fetchEventById(eventId));
            }
        }

        componentWillReceiveProps({ eventId }) {
            if (this.props.eventId !== eventId && eventId) {
                this.props.dispatch(fetchEventById(eventId));
            }
        }

        onProviderSelect = (e, i, val) => {
            this.props.dispatch(setProvider(val));
            //  this.clearOddsSelection();
        };

        clearOddsSelection = () => {
            this.onOddSelect({ market: null, outcome: null, text: null, link: null, outcomeObject: null });
        };

        renderProviderSelect() {
            const { defaultProvider, selectedProvider: provider } = this.props;
            const { providers, textGenerating } = this.state;
            const hideProviderSelect =
                (providers.length < 2 &&
                    providers.some(e => e.id === defaultProvider) &&
                    defaultProvider === provider) ||
                providers.length === 0;
            return hideProviderSelect ? null : (
                <SelectField
                    disabled={textGenerating}
                    value={provider}
                    floatingLabelText={'Odds provider'}
                    onChange={this.onProviderSelect}
                >
                    {providers.map(b => <MenuItem key={b.id} value={b.id} primaryText={b.name} />)}
                </SelectField>
            );
        }

        onCampaignSelect = (e, i, val) => {
            this.props.dispatch(setCampaign(val));
            if (this.props.onCampaignChange) {
                this.props.onCampaignChange(val);
            }
        };

        closeCreateCampaign = id => {
            if (typeof id === 'string') {
                this.props.dispatch(setCampaign(id));
                this.setState({ showCreateCampaign: false });
                if (this.props.onCampaignChange) {
                    this.props.onCampaignChange(id);
                }
            } else {
                this.setState({ showCreateCampaign: false });
            }
        };

        refresh = () => {
            const { markets, eventId, selectedProvider: provider } = this.props;
            markets.forEach(market => {
                this.props.dispatch(fetchOdds(eventId, market, provider));
            });
        };

        renderItems() {
            const { eventId, markets, disabled } = this.props;
            return markets.map((market, index) => (
                <MarketItem key={market} market={market} eventId={eventId} disabled={disabled} />
            ));
        }

        renderCampaignSelect() {
            const { socialCampaigns, selectedCampaign } = this.props;
            const { showCreateCampaign } = this.state;
            const campaigns = Array.isArray(socialCampaigns) ? socialCampaigns : [];
            return (
                <div>
                    {campaigns.length ? (
                        <SelectField
                            floatingLabelText={'Social campaign'}
                            value={selectedCampaign}
                            onChange={this.onCampaignSelect}
                        >
                            <MenuItem primaryText={'None'} value={emptyValue} />
                            {campaigns.map(c => <MenuItem key={c._id} primaryText={c.name} value={c._id} />)}
                        </SelectField>
                    ) : (
                        <p>No social campaigns</p>
                    )}
                    <div>
                        <FlatButton
                            label={'+ Create campaign'}
                            onClick={() => this.setState({ showCreateCampaign: true })}
                        />
                    </div>
                    <Dialog
                        title={'Create social campaign'}
                        open={showCreateCampaign}
                        onRequestClose={this.closeCreateCampaign}
                        className={'no-padding-dialog'}
                        autoScrollBodyContent
                        autoDetectWindowHeight
                    >
                        <CreateSocialCampaign onCreate={this.closeCreateCampaign} />
                    </Dialog>
                </div>
            );
        }

        renderRefresh() {
            const { disabled, eventId, selectedProvider: provider } = this.props;
            return (
                <IconButton disabled={disabled || !eventId || !provider} tooltip={'Refresh'} onClick={this.refresh}>
                    <RefreshIcon />
                </IconButton>
            );
        }

        render() {
            return (
                <div style={{ display: 'flex' }}>
                    <div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            {this.renderProviderSelect()}
                            {this.renderRefresh()}
                        </div>
                        {this.renderItems()}
                        {this.renderCampaignSelect()}
                    </div>
                </div>
            );
        }
    }
);



/** WEBPACK FOOTER **
 ** ../src/dash/front/odds/OddsList.js
 **/